// ---------------------------------------------------------------------------
// ag-grid stylesheet ordering. THE ORDER OF THESE IMPORTS IS LOAD-BEARING.
//
// ag-grid 29 uses the legacy CSS themes: `ag-grid.css` carries the structural
// rules, and each `ag-theme-*.css` layers the visuals on top. Many theme rules
// tie with a base rule on specificity -- base `.ag-ltr .ag-cell` vs theme
// `.ag-theme-material .ag-cell` are both 0-2-0 -- so the winner is decided
// purely by which stylesheet the bundler emits last. Themes must come after
// the base or the grids render with the bare structural styling.
//
// 23 modules across this app and the mesf-core library import these
// stylesheets ad hoc, and the bundler emits each one where it is first reached
// in the module graph, so the cascade used to be an accident of import order.
// It broke when mesf-core stopped being a prebuilt npm package: the library
// barrel re-exports `./account`, whose `account.tsx` imports
// `ag-theme-material.css`, which hoisted that theme to the front of the entry
// stylesheet, ~20 kB ahead of the structural base. Every tie then flipped to
// the base and the themes stopped applying.
//
// Pinning all four here, base first, makes the order deterministic. This
// module is the first import in `src/index.tsx`, so every later import of the
// same stylesheets dedupes to these positions.
//
// These are sorted alphabetically on purpose: `ag-grid.css` sorts ahead of
// every `ag-theme-*.css`, so the correct order is also the sorted order and
// the biome pre-commit hook cannot silently reshuffle it. `vite.config.ts`
// aliases `ag-grid-enterprise/styles/*` onto these same community files (they
// are byte-identical) so there is only one module identity per stylesheet and
// no unpinned duplicate can slip in after the themes.
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-balham.min.css";
import "ag-grid-community/styles/ag-theme-material.css";
import "ag-grid-community/styles/ag-theme-material.min.css";

import { LicenseManager } from "ag-grid-enterprise";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;

LicenseManager.setLicenseKey(licenseKey);
